// extracted by mini-css-extract-plugin
module.exports = {"appLayout":"src-style-module__appLayout--143YG","appContent":"src-style-module__appContent--1PZp-"};